export function getCookie(cname: string): string | null {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return null;
}

type SetCookieOptions = {
  expiration?: string | number;
  path?: string;
  sameSite?: "Strict" | "Lax" | "None";
  secure?: boolean;
};

export function setCookie(name: string, value: string, options: SetCookieOptions = {}): void {
  const { expiration, path, sameSite = "Lax", secure = location.protocol === "https:" } = options;

  let str = name + "=" + value + ";";

  if (expiration) {
    str += " expires=" + expiration.toString() + ";";
  }

  if (path) {
    str += " path=" + path + ";";
  }

  str += " SameSite=" + sameSite + ";";

  if (secure) {
    str += " Secure;";
  }

  document.cookie = str;
}

export function deleteCookie(name: string, path = "/"): void {
  if (!getCookie(name)) {
    return;
  }

  const expiration = Date.now() - 3600 * 24 * 30 * 12; // circa one year into the past
  setCookie(name, "", { expiration, path });
}
